import React, { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { BaseFormFields, useBaseForm } from "./BaseFormFields";

export function ServiceRequestForm({ onSubmit, initialData, readOnly, submitting, onTitleChange, allowedPriorities, ticketType, onTypeChange }) {
    const baseForm = useBaseForm("low");
    const [serviceType, setServiceType] = useState("");
    const [desiredDeliveryDate, setDesiredDeliveryDate] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            title: baseForm.title,
            description: baseForm.description,
            priority: baseForm.priority,
            dynamic_fields: {
                service_type: serviceType,
                desired_delivery_date: desiredDeliveryDate,
            },
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <BaseFormFields
                ticketType={ticketType}
                onTypeChange={onTypeChange}
                {...baseForm}
                onTitleChange={onTitleChange}
                    allowedPriorities={allowedPriorities}
                titlePlaceholder="Ex: Demande de configuration salle de réunion"
                descriptionPlaceholder="Décrivez votre demande de service..."
            >
                <div className="form-group">
                    <Label className="form-label">Type de service</Label>
                    <Input
                        value={serviceType}
                        onChange={(e) => setServiceType(e.target.value)}
                        placeholder="Ex: Configuration, Déménagement, Formation..."
                        data-testid="service-type"
                    />
                </div>

                <div className="form-group">
                    <Label className="form-label">Date souhaitée</Label>
                    <Input
                        type="date"
                        value={desiredDeliveryDate}
                        onChange={(e) => setDesiredDeliveryDate(e.target.value)}
                        data-testid="delivery-date"
                    />
                </div>
            </BaseFormFields>

            <div className="mt-6 flex justify-end">
                <Button type="submit" disabled={!baseForm.title || !baseForm.description || submitting} data-testid="submit-ticket">
                    {submitting ? "Création..." : "Soumettre le ticket"}
                </Button>
            </div>
        </form>
    );
}
